import React from 'react';

import {Form, FormikProps} from 'formik';
import {CallMade} from '@material-ui/icons';
import {Box} from '@material-ui/core';

import PropTypes from 'prop-types';
import {useSpinner} from 'hooks';
import {InferPropTypes} from 'commons/types/Types';
import {Bullet, ResetPasswordValues} from 'commons/models';
import {FlexBoxClasses} from 'assets/tss/commons/Flex';
import {BottomContent, MainContent} from 'layouts/commons';
import {EfeBulletList, EfeButtonPrimary, EfeErrorMsg, EfePasswordField} from 'components';
import {data} from 'commons/defaults/recover-password';

InnerFormPassword.propTypes = {
    isLoading: PropTypes.bool.isRequired,
};

function InnerFormPassword(
    props: InferPropTypes<typeof InnerFormPassword.propTypes> & FormikProps<ResetPasswordValues>
) {
    const {isLoading, values, handleBlur, handleChange, errors, isSubmitting} = props;

    const bullets: Array<Bullet> = data;

    return (
        <Form noValidate>
            <MainContent>
                {useSpinner(isLoading)}
                <Box flexGrow={0}>
                    <EfeBulletList bullets={bullets} />
                </Box>
                <Box sx={FlexBoxClasses}>
                    <Box>
                        <EfePasswordField
                            label={'Nueva contrase\u00F1a'}
                            name='newPassword'
                            handleBlur={handleBlur}
                            handleChange={handleChange}
                            value={values.newPassword}
                            disableHelper={true}
                            error={!!errors.newPassword}
                        />
                        {errors.newPassword && <EfeErrorMsg message={errors.newPassword} />}
                    </Box>
                    <Box pt={4}>
                        <EfePasswordField
                            label={'Confirmar nueva contrase\u00F1a'}
                            name='passwordConfirmed'
                            handleBlur={handleBlur}
                            handleChange={handleChange}
                            value={values.passwordConfirmed}
                            disableHelper={true}
                            error={!!errors.passwordConfirmed}
                        />
                        {errors.passwordConfirmed && (
                            <EfeErrorMsg message={errors.passwordConfirmed} />
                        )}
                    </Box>
                </Box>
            </MainContent>
            <BottomContent>
                <EfeButtonPrimary disabled={isSubmitting} endIcon={<CallMade />} type='submit'>
                    {'Guardar'}
                </EfeButtonPrimary>
            </BottomContent>
        </Form>
    );
}

export default InnerFormPassword;
